import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, HeadlineL } from '#src/atoms/typography/index.tsx';
import { LEARN_MORE_ABOUT_DOCUMENT_CHECK } from '#src/components/fiatWallet/CreateFiatWallet/externalLinks.ts';
import { CreateFiatWalletSteps } from '#src/components/fiatWallet/CreateFiatWallet/type.ts';
import { useFiatBalance } from '#src/hooks/wallets/useFiatBalance.ts';
import { refusedReasonsMessages } from '#src/lib/mangopay.ts';

const StyledButtonBase = styled.a`
  color: var(--c-link);
  text-decoration: underline;
`;

type Props = {
  setStep: (step: CreateFiatWalletSteps) => void;
};

export const HandleIdReviewError = ({ setStep }: Props) => {
  const { refusedReason } = useFiatBalance();

  return (
    <Vertical gap={2}>
      <HeadlineL as="h3">
        <FormattedMessage
          id="createFiatWallet.handleIdReviewError.title"
          defaultMessage="Let’s try again"
        />
      </HeadlineL>
      <BodyM>
        {!!refusedReason && (
          <FormattedMessage {...refusedReasonsMessages[refusedReason]} />
        )}
      </BodyM>
      <BodyM bold>
        <StyledButtonBase
          href={LEARN_MORE_ABOUT_DOCUMENT_CHECK}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage
            id="createFiatWallet.handleIdReviewError.learnHowIdentityVerificationWorks"
            defaultMessage="Learn how identity verification works."
          />
        </StyledButtonBase>
      </BodyM>
      <Button
        color="primary"
        size="medium"
        onClick={() =>
          setStep(CreateFiatWalletSteps.REVIEW_INFO_BEFORE_ADDING_ID)
        }
      >
        <FormattedMessage
          id="createFiatWallet.handleIdReviewError.button"
          defaultMessage="Resubmit ID"
        />
      </Button>
    </Vertical>
  );
};
